<template>
  <div>
    <p style="color:#aaa;">
        These tools will help you boost sales based on your strategy. Consult the SoldOutt team for suggestions on how to use them.
      </p>
      <section>
        <h1 class="py-5">Promo Text</h1>
        <!-- <div class="vx-row mb-6" v-if="basicForm.wht_status"> -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Promo Text</span>
            <div style="font-size:0.75rem; color:#aaa;">
                Shown as a box on the Register page. Good for emphasizing a message or an offer.
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-textarea
              rows="5"
              style="width: 100%"
              v-model="bootsalesForm.promotext"
              label-placeholder=" "
            />
          </div>
        </div>
        <!-- <vs-divider></vs-divider> -->
      </section>

      <hr>

      <section>
        <h1 class="py-5">Countdown</h1>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Countdown</span>
            <div style="font-size:0.75rem; color:#aaa;">
                Countdown on the Register Page to trigger action. This is good for Flash Sale or limited time offers.
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  vs-name="radios-engnameonly"
                  v-model="bootsalesForm.countdown"
                  :vs-value="1"
                  >Show</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  vs-name="radios-engnameonly"
                  v-model="bootsalesForm.countdown"
                  :vs-value="0"
                  >Hide</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
        <div v-if="bootsalesForm.countdown === 1" class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Countdown Text</span>
            <div style="font-size:0.75rem; color:#aaa;">
                Text placed next to the countdown
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-textarea
              rows="5"
              style="width: 100%"
              v-model="bootsalesForm.countdowntext"
              label-placeholder=" "
            />
          </div>
        </div>

      </section>

      <hr>

      <section >
        <h1 class="py-5">Sold Bar</h1>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Sold Bar</span>
            <div style="font-size:0.75rem; color:#aaa;">Bar showing how many tickets have been sold</div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  vs-name="radios-soldbar"
                  v-model="bootsalesForm.soldbar"
                  :vs-value="1"
                  >Show</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  vs-name="radios-soldbar"
                  v-model="bootsalesForm.soldbar"
                  :vs-value="0"
                  >Hide</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
        <div v-if="bootsalesForm.soldbar === 1 && false" class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Period</span>
            <div style="font-size:0.75rem; color:#aaa;"></div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <!-- <flat-pickr
                :config="configdateTimePicker"
                v-model="bootsalesForm.soldbar_start"
                placeholder="Date Time Start"
              />
              <span class="mx-4">to</span>
              <flat-pickr
                :config="configdateTimePicker"
                v-model="bootsalesForm.soldbar_end"
                placeholder="Date Time End"
              /> -->
              <!-- <el-date-picker
                v-validate="'required'"
                name="daterange"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm"
                format="dd-MM-yyyy HH:mm"
                v-model="bootsalesForm.bootSaleRange"
                type="datetimerange"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                @change="checkBootSaleRange"
              ></el-date-picker> -->
              <el-date-picker
              v-validate="'required'"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm"
              format="dd-MM-yyyy HH:mm"
              v-model="date"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              @input="checkBootSaleRange"
              popper-class="custom-date-picker"
            ></el-date-picker>
          </div>
        </div>
      </section>

      <hr>

      <section>
        <h1 class="py-5">Social Proof</h1>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Social Proof</span>
            <div style="font-size:0.75rem; color:#aaa;">Pop-in notifications that show the most recent booking with buyer name and location</div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  vs-name="radios-socialproof"
                  v-model="bootsalesForm.socialproof"
                  :vs-value="1"
                  >Show</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  vs-name="radios-socialproof"
                  v-model="bootsalesForm.socialproof"
                  :vs-value="0"
                  >Hide</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
      </section>

      <hr>

      <section>
        <h1 class="py-5">Exit Pop-up</h1>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Exit Pop-up</span>
            <div style="font-size:0.75rem; color:#aaa;">Pop-up that shows when the buyer attempts to close the browser tab</div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  vs-name="radios-exitpopup"
                  v-model="bootsalesForm.exitpopup"
                  :vs-value="1"
                  >Show</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  vs-name="radios-exitpopup"
                  v-model="bootsalesForm.exitpopup"
                  :vs-value="0"
                  >Hide</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
        <div v-if="bootsalesForm.exitpopup === 1" class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Exit Pop-up Text</span>
            <div style="font-size:0.75rem; color:#aaa;">Text shown in the pop-up</div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-textarea
              rows="5"
              style="width: 100%"
              v-model="bootsalesForm.exitpopuptext"
              label-placeholder=" "
            />
          </div>
        </div>
      </section>

      <hr>

      <section>
        <h1 class="py-5">Friend-get-friend</h1>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Friend-get-friend</span>
            <div style="font-size:0.75rem; color:#aaa;">Allow ticket holders to invite friends by sharing a referrer link</div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  vs-name="radios-friendgetfriend"
                  v-model="bootsalesForm.friendgetfriend"
                  :vs-value="1"
                >
                  On
                </vs-radio>
              </li>
              <li>
                <vs-radio
                  vs-name="radios-friendgetfriend"
                  v-model="bootsalesForm.friendgetfriend"
                  :vs-value="0"
                >
                  Off
                </vs-radio>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="bootsalesForm.friendgetfriend === 1" class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Invite Text</span>
            <div style="font-size:0.75rem; color:#aaa;">If you have an incentive for inviter, put them here</div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-textarea
              rows="5"
              style="width: 100%"
              v-model="bootsalesForm.invitetext"
              label-placeholder=" "
            />
          </div>
        </div>
      </section>
      <hr>
    <div class="vx-row pt-2 mt-0">
        <div class="vx-col w-full ml-auto">
          <vs-button class="mr-3 mb-2" @click="submitBootsale">Save </vs-button>

          <vs-button class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
        </div>
      </div>
  </div>
</template>
<script>
import moment from "moment";
// import { mapState } from "vuex";
import Service from "@/services";

// import { currencyList, protypeList } from "@/utils/Constants";
// import { timezones } from "@/utils/Timezones";
// import { eventFieldsPermission } from "@/utils/FieldsPermission";

import { basicForm, bootsalesForm } from "@/utils/eventForm";
import VxCard from '../../vx-card/VxCard.vue';

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    VxCard,
    flatPickr
  },
  props: {
    event: null,
    role: null,
    basicForm: basicForm,
    bootsalesForm: bootsalesForm,
    folder: null,
    soldbarData: []
  },
  // computed: {
  //   checkBootSaleRange(val) {
  //     return console.log(val, 'fewfwef')
  //   }
  // },
  data() {
    return {
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
      },
      daterangeSoldbar: null,
      date: []
    };
  },
  methods: {
    // submitBootsale() {
    //     this.bootsalesForm.e = this.folder
    // },
    submitBootsale() {
      this.basicForm.e = this.folder;

      /*CONVERT DATE FORMAT */
      this.bootsalesForm.soldbar_start = moment(this.bootsalesForm.bootSaleRange[0]).format("YYYY-MM-DD HH:mm");
      this.bootsalesForm.soldbar_end = moment(this.bootsalesForm.bootSaleRange[1]).format("YYYY-MM-DD HH:mm");

      this.basicForm.datetime = moment(this.basicForm.daterange[0]).format("YYYY-MM-DD HH:mm");
      this.basicForm.datetime_end = moment(this.basicForm.daterange[1]).format("YYYY-MM-DD HH:mm");
      console.log(this.basicForm.datetime, this.basicForm.datetime_end);
      // if (this.basicForm.datetime == "Invalid date") {
      //   this.basicForm.datetime = moment(
      //     this.basicForm.daterange[0],
      //     "DD-MM-YYYY HH:mm"
      //   ).format("YYYY-MM-DD HH:mm");
      // }

      // if (this.basicForm.datetime_end == "Invalid date") {
      //   this.basicForm.datetime_end = moment(
      //     this.basicForm.daterange[1],
      //     "DD-MM-YYYY HH:mm"
      //   ).format("YYYY-MM-DD HH:mm");
      // }

      // if (this.basicForm.featured_status == 0) {
      //   this.basicForm.featured_status = null;
      // }

      this.$vs.loading();

      Service.Event.update({
        ...this.bootsalesForm,
        ...this.basicForm,
        e: this.basicForm.e,
        invitetext: this.bootsalesForm.invitetext,
        pay_creditcard: (this.event.pay_creditcard === null && this.basicForm.pay_creditcard === 1) ? null: this.basicForm.pay_creditcard ,
        pay_transfer: (this.event.pay_transfer === null && this.basicForm.pay_transfer === 1) ? null: this.basicForm.pay_transfer ,
        fields_status: this.event.fields_status === null ? null: this.basicForm.fields_status,
      })
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    canceled() {
      this.$router.push(`/dash`)
    },
    checkBootSaleRange(val) {
      this.bootsalesForm.bootSaleRange = val
      this.date = val
    }
  },
  mounted() {
    this.date = this.bootsalesForm.bootSaleRange
  }
};
</script>
